import { Navigate } from 'react-router-dom';

import Auth from 'utils/Auth';
import PATHS, { AuthPath, DASHBOARD_PATHS } from './paths';

export default function RootRedirect() {
  if (Auth.isAuthenticated()) {
    return <Navigate to={`${PATHS.DASHBOARD}/${DASHBOARD_PATHS.TOP_DIRECTORY}`} replace />;
  }

  return <Navigate to={`/${AuthPath.LOGIN}`} replace />;
}
